import React from "react";

const AdminHomePage = () => {
  return <div>AdminHomePage</div>;
};

export default AdminHomePage;
